import React, { lazy, Suspense } from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { Page } from "./types";
import ScrollToTop from "./ScrollToTop";
import Fallback from "./fallback";
// import Footer from "shared/Footer/Footer";
// import SiteHeader from "containers/SiteHeader";
// import AuthorPage from "containers/AuthorPage/AuthorPage";
// import AccountPage from "containers/AccountPage/AccountPage";
// import PageAbout from "containers/PageAbout/PageAbout";
// import PageSignUp from "containers/PageSignUp/PageSignUp";
// import PageLogin from "containers/PageLogin/PageLogin";
// import PageSubcription from "containers/PageSubcription/PageSubcription";
// import BlogPage from "containers/BlogPage/BlogPage";
// import BlogSingle from "containers/BlogPage/BlogSingle";
// import PageCollection from "containers/PageCollection";

const PageHome = lazy(() => import("pages/Home"));
const TermsPage = lazy(() => import("pages/Terms"));
// Admin page only available in development
const AdminPage = process.env.NODE_ENV === "development"
  ? lazy(() => import("pages/Admin"))
  : null;
// const PageSearch = lazy(() => import("pages/Explore"));
// const PageContact = lazy(() => import("pages/Contact"));
// const PageConnectWallet = lazy(() => import("pages/ConnectWallet"));
// const PageUploadItem = lazy(() => import("pages/NFT/create"));
// const NftEditPage = lazy(() => import("pages/NFT/edit"));
// const NftDetailPage = lazy(() => import("pages/NFT"));
const Page404 = lazy(() => import("pages/Page404"));

export const pages: Page[] = [
  { path: "/", exact: true, component: PageHome },
  { path: "/#", exact: true, component: PageHome },
  { path: "/terms", exact: true, component: TermsPage },
  // Admin only in development - not deployed to production
  ...(AdminPage ? [{ path: "/admin" as const, exact: true, component: AdminPage }] : []),
  // { path: "/home2", exact: true, component: PageHome },
  // { path: "/home3", exact: true, component: PageHome3 },
  //
  // { path: "/home-header-2", exact: true, component: PageHome },
  // { path: "/page-collection", component: PageCollection },
  // { path: "/page-author", component: AuthorPage },
  // { path: "/account", component: AccountPage },
  // { path: "/nfts/create", component: PageUploadItem },
  // { path: "/nfts/:tokenId/edit", component: NftEditPage },
  // { path: "/nfts/:tokenId", component: NftDetailPage },
  // // { path: "/nfts", component: PageSearch },
  // { path: "/connect-wallet", component: PageConnectWallet },
  //
  // { path: "/blog", component: BlogPage },
  // { path: "/blog-single", component: BlogSingle },
  // //
  // { path: "/contact", component: PageContact },
  // { path: "/about", component: PageAbout },
  // { path: "/signup", component: PageSignUp },
  // { path: "/login", component: PageLogin },
  // { path: "/subscription", component: PageSubcription },
];

const Routes = () => {
  return (
    <BrowserRouter basename="/">
      <ScrollToTop />
      {/* <SiteHeader /> */}
      <Suspense fallback={<Fallback />}>
        <Switch>
          {pages.map(({ component, path, exact }) => {
            return (
              <Route
                key={path}
                component={component}
                exact={!!exact}
                path={path}
              />
            );
          })}
          <Route component={Page404} />
        </Switch>
      </Suspense>
      {/* <Footer /> */}
    </BrowserRouter>
  );
};

export default Routes;
